import React, { useEffect, useState, Fragment } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../layout/Loader';
import MetaData from '../layout/MetaData';
import { login, clearError } from '../../actions/userActions';
import { IMAGES } from '../../constants';
import { AddressApi2, url } from '../../config';
import { validateFields } from '../../validation';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import mixpanel from 'mixpanel-browser';
import $ from 'jquery';
import ContactUsPopUp from '../HomePage/ContactUsPopUp';
import { useIntl } from 'react-intl';
import { set } from 'react-hook-form';
import axios from 'axios';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordshow, setPasswordshow] = useState(false)
    const [address , setAddress] = useState({})
    const [validerror, setValidError] = useState({
        emailError: "",
        passwordError: ""
    });

    const alert = useAlert();
    const history = useHistory();
    const dispatch = useDispatch();

    const { isAuthenticated, error, user, loading } = useSelector(state => state.user)
    const handleContactUsPopUp = (event) => {
        $("#popup-click-confirm").trigger('click');
    }
    const handleResForm = (status) => {
        $("#dismiss-modal").trigger('click');
    }

    useEffect(() => {
        if (isAuthenticated) {
            if (user?.is_business_step === 0) {
                history.push(url + "/business-info");
                return;
            }
            if (user?.country_id === 225) {
                localStorage.setItem("country", 'turkey')
            } else {
                localStorage.setItem("country", 'uk')
            }
            history.push(url + "/category/diamonds")
        }
        if (error) {
            dispatch(clearError());
            alert.error(error?.message)
        }
        if(error?.badge == "1"){
        //   history.push(url + "/device-list" ,   state: { someData: "value" })
        history.push({pathname: url + "/device-list/web",state: error?.security_token});

        }
    }, [dispatch, error, isAuthenticated, history, alert, user])

    const handleShowPassword = () => {
        let x = document.getElementById('ty-pass');
        setPasswordshow(!passwordshow)
        if (x.type === "password") { x.type = "text" } else { x.type = "password" }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const emailError = validateFields.validateEmail(email);
        const passwordError = validateFields.validatePassword(password);
        if (localStorage.getItem('new_uuid')) {
            localStorage.setItem('uuid',localStorage.getItem('new_uuid'))
            localStorage.removeItem('new_uuid')
        }

        if ([emailError, passwordError].every(e => e === false)) {
            setValidError({
                ...validerror, emailError, passwordError
            })
            const sendData = {
                email: email,
                password: password,
                address : address
            }
            localStorage.setItem('user_data', JSON.stringify(sendData));
            dispatch(login(email, password , address))
        }
        else {
            setValidError({
                ...validerror, emailError, passwordError
            })
        }
        return;
    }

    useEffect(() => {
        mixpanel.track('Login')
    }, [])

    useEffect(()=>{
        if(!localStorage.getItem('address')){
           axios.get(`${AddressApi2}`).then((res) => {
            setAddress(res?.data)
              localStorage.setItem('address' , JSON.stringify(res?.data))
             }).catch((err) => {
            console.log(err)
            }).catch((err)=>{
                alert.error(err)
            })
       }else{
        setAddress(JSON.parse(localStorage.getItem('address')))
       } 
    },[])

    useEffect(() => {
        if (history?.location?.search?.split('?lang=')[1] && localStorage.getItem("lang") != history?.location?.search?.split('?lang=')[1]) {
            localStorage.setItem("lang", history?.location?.search?.split('?lang=')[1]);
            window.location.reload();
        }
    }, [history])

    return (
        <Fragment>
            {loading && <Loader />}
            <Fragment>
                <MetaData title={'login'} />
                <form onSubmit={handleSubmit}>
                    <section className="container">
                        <div className="row justify-content-md-center">
                            <div className="col-md-5 mt-5">
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <Link to={url}><img className="mb-4" src={IMAGES.LOGO} alt="" /></Link>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 Loginbox p-4">
                                        <h4 className="font-20 black-3B fb my-4">
                                            <FormattedMessage
                                                id="login.log-in-to-you-account"
                                                defaultMessage="Log in to you account"
                                            />
                                        </h4>
                                        <div className="form-group">
                                            <label htmlFor="">
                                                <FormattedMessage
                                                    id="login.email-address"
                                                    defaultMessage="Email address"
                                                />
                                            </label>
                                            <input type="text" placeholder="Email" className={classnames("form-control", { 'is-valid': validerror.emailError === false }, { 'is-invalid': validerror.emailError })} value={email} onChange={(e) => setEmail(e.target.value)} />
                                            <p className="invalid-feedback">{validerror.emailError}</p>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="">
                                                <FormattedMessage
                                                    id="login.password"
                                                    defaultMessage="Password"
                                                />
                                                *
                                            </label>
                                            <input type="password" id="ty-pass" placeholder="********" className={classnames("form-control", { 'is-valid': validerror.passwordError === false }, { 'is-invalid': validerror.passwordError })} value={password} onChange={(e) => setPassword(e.target.value)} />
                                            <span className="input_icon"><img style={{width:"20px"}} src={!passwordshow ? IMAGES.VIEW_CLOSE : IMAGES.VIEW_SVG} alt="show/hide" onClick={handleShowPassword} /></span>
                                            <p className="invalid-feedback">{validerror.passwordError}</p>
                                        </div>
                                        <button type="submit" className="btn-lg full btn-black my-4 ">
                                            <FormattedMessage
                                                id="login.login"
                                                defaultMessage="Login"
                                            />
                                        </button>
                                        <Link to={url + "/forget-password"}><button type="button" className="btn-lg full btn-grey mb-4 ">
                                            <FormattedMessage
                                                id="login.forgotpassword"
                                                defaultMessage="Forgot Password ?"
                                            />
                                            ?
                                        </button></Link>

                                        <p className="acntHelp m-0">
                                            <span>
                                                <FormattedMessage
                                                    id="login.dont-have-an-account"
                                                    defaultMessage="Don’t have an account ?"
                                                />
                                                <span>{` `}</span>
                                                <Link to={url + "/register"}>
                                                    <FormattedMessage
                                                        id="main.header.signup"
                                                        defaultMessage="Sign Up"
                                                    />
                                                </Link></span>
                                            <Link onClick={handleContactUsPopUp}>
                                                <span className="float-right">
                                                    <FormattedMessage
                                                        id="main.header.contactsales"
                                                        defaultMessage="Contact Sales"
                                                    />
                                                </span>
                                            </Link>
                                        </p>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>
                </form>
                {
                    <ContactUsPopUp
                        message={useIntl().formatMessage({ id: 'deleteAllProducts' })}
                        title={useIntl().formatMessage({ id: 'Confirmation' })}
                        handleResForm={handleResForm}
                    />
                }
            </Fragment>
        </Fragment>
    )
}

export default Login